import React from 'react'
import DataField from "../../../utils/DataField"
import {titleCase} from "../../../utils/utils"
import moment from "moment"
import { useTranslation } from "react-i18next";

function CinDigitalOCR(props){

    const { t } = useTranslation()

    const { OCR } = props

    const formatDate = (date) => date ? moment(date).format('DD/MM/YYYY') : null

    const formatFlag = (flag) => typeof flag === "boolean" ? (flag ? t("yes") : t("no")) : null

    return(
        <div style={{display:"flex", width:"70%", flexDirection: "column"}}>
            <DataField
                title={t("name")}
                label={titleCase(OCR.name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("cpf")}
                label={OCR.cpf_number ? OCR.cpf_number : null}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("birthdate")}
                label={formatDate(OCR.birthdate)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("father_name")}
                label={titleCase(OCR.father_name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("mother_name")}
                label={titleCase(OCR.mother_name, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("place_of_birth")}
                label={titleCase(OCR.place_of_birth, null)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("issuance_date")}
                label={formatDate(OCR.issuance_date)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("expiration_date")}
                label={formatDate(OCR.expiration_date)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("illiterate_person")}
                label={formatFlag(OCR.found_illeterate_person_text)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
            <DataField
                title={t("person_with_disability")}
                label={formatFlag(OCR.has_disability)}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
            />
        </div>
    )
}

export default CinDigitalOCR
